import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	justify-content: center;
	align-items: center;
	padding: 5rem;
`;